import { render, staticRenderFns } from "./ReferenceField.vue?vue&type=template&id=0f179498&scoped=true&"
import script from "./ReferenceField.vue?vue&type=script&lang=js&"
export * from "./ReferenceField.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceField.vue?vue&type=style&index=0&id=0f179498&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f179498",
  null
  
)

export default component.exports